module.exports = __webpack_public_path__ + "static/media/arrow_left.4afea05c.svg";